import { render, staticRenderFns } from "./itemImage.vue?vue&type=template&id=e0cae3fe&scoped=true&lang=html&"
import script from "./itemImage.vue?vue&type=script&lang=js&"
export * from "./itemImage.vue?vue&type=script&lang=js&"
import style0 from "./itemImage.vue?vue&type=style&index=0&id=e0cae3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cae3fe",
  null
  
)

export default component.exports